import { compact } from 'lodash'
import { TTS_MODES } from '@edulastic/constants/const/test'

// Must stay identical to the backend implementation.

const MODE_VALUES = Object.values(TTS_MODES)

export const isValidTtsMode = (mode) => MODE_VALUES.includes(mode)

export const boolToMode = (value) => {
  if (value === true) return TTS_MODES.ENABLE_ALL
  if (value === false) return TTS_MODES.DISABLE
  return TTS_MODES.STUDENT_LEVEL
}

export const modeToBool = (mode) => {
  if (mode === TTS_MODES.ENABLE_ALL) return true
  if (mode === TTS_MODES.DISABLE) return false
  return undefined
}

export const resolveItemTtsMode = ({
  classItemTtsMode,
  showTextToSpeech,
} = {}) =>
  (isValidTtsMode(classItemTtsMode) && classItemTtsMode) ||
  boolToMode(showTextToSpeech)

const normalizeSubjects = (subjects) =>
  compact(Array.isArray(subjects) ? subjects : [subjects])
    .filter((s) => typeof s === 'string')
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean)

export const isTtsSubjectMatch = ({ ttsScopeSubjects, testSubjects } = {}) => {
  const scope = normalizeSubjects(ttsScopeSubjects)
  const subjects = normalizeSubjects(testSubjects)
  if (!scope.length || !subjects.length) return true
  return subjects.some((s) => scope.includes(s))
}

export { TTS_MODES }

// Idempotent when the backend already resolved showTextToSpeech for the class.
export const getClassResolvedShowTextToSpeech = (assignment, classId) => {
  const classSettings = (assignment?.class || []).find(
    (_class) => _class?._id === classId
  )
  return modeToBool(
    resolveItemTtsMode({
      classItemTtsMode: classSettings?.itemTtsMode,
      showTextToSpeech: assignment?.showTextToSpeech,
    })
  )
}

// Realtime addAssignment payloads are broadcast per class, so the per-student
// values sent by POST /assignments/all (ttsSubjectMatch etc.) are derived here.
export const resolveRealtimeAssignmentTts = (
  assignment,
  { classIds = [], ttsScopeSubjects } = {}
) => {
  if (!assignment || typeof assignment !== 'object') return assignment
  const classSettings = (assignment.class || []).find((_class) =>
    classIds.includes(_class?._id)
  )
  const resolved = {
    ...assignment,
    showTextToSpeech: modeToBool(
      resolveItemTtsMode({
        classItemTtsMode: classSettings?.itemTtsMode,
        showTextToSpeech: assignment.showTextToSpeech,
      })
    ),
  }
  if (
    typeof assignment.ttsSubjectMatch !== 'boolean' &&
    typeof assignment.ttsSubjectScopeEnabled === 'boolean'
  ) {
    resolved.ttsSubjectMatch =
      !assignment.ttsSubjectScopeEnabled ||
      isTtsSubjectMatch({
        ttsScopeSubjects,
        testSubjects: assignment.testSubjects,
      })
  }
  return resolved
}
